
import type { CrremYearlyPoint } from "../model/types";

import { collectChartYears, valueAtYear } from "./collectPathwayYears";

export type LegacyCrremRow = {
  climate: number | undefined;
  crrem: number | undefined;
  current: number | undefined;
  id: number;
  project: number;
  year: number;
};

const toFiniteNumber = (value: null | number | undefined) =>
  typeof value === "number" && Number.isFinite(value) ? value : undefined;

export const mapPathwayToLegacyCrremRows = ({
  baselinePoints,
  currentPoints,
  pathwayPoints,
  projectId,
}: {
  baselinePoints: CrremYearlyPoint[];
  currentPoints: CrremYearlyPoint[];
  pathwayPoints: CrremYearlyPoint[];
  projectId: number | string;
}): LegacyCrremRow[] => {
  const project = Number(projectId);
  return collectChartYears([baselinePoints, currentPoints, pathwayPoints], [])
    .map((year) => ({
      climate: toFiniteNumber(valueAtYear(currentPoints, year)),
      crrem: toFiniteNumber(valueAtYear(pathwayPoints, year)),
      current: toFiniteNumber(valueAtYear(baselinePoints, year)),
      id: year,
      project: Number.isFinite(project) ? project : 0,
      year,
    }));
};
